module.exports = __webpack_public_path__ + "static/media/wander-hungerbuhler.a14dece0.png";